import psHttp from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix, ANALYTICS_URI, coreSearchApiUrlPrefix, chemicalAipUrlPrefix } from '@cores/constants/envConfig';
import _ from 'lodash';
import qs from 'qs';
import { getCurrentLanguage } from '@cores/utils/getCurrentLanguage';
import { currentClientUUID } from '@patsnap/uniform-setting';
export default async function getInit() {
    const { data } = await psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/commonConfig`,
        method: 'GET',
        cache: true,
    });
    return data || {};
}
export function exportPatentApi({ params = {}, data = {}, }) {
    const _data = _.cloneDeep(data);
    if (_.get(_data, 'patent_ids.length') === 0) {
        delete _data.patent_ids;
    }
    if (_.isEmpty(_data)) {
        return Promise.resolve({
            query_string: `${ANALYTICS_URI}/export?${qs.stringify(params)}`,
        });
    }
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/patents/export`,
        method: 'POST',
        data: _data,
        transformCode: true,
    }).then(({ data }) => {
        const query_id = _.get(data, 'data.query_id') || '';
        return {
            query_string: `${ANALYTICS_URI}/export?${qs.stringify({ ...params, query_id })}`,
        };
    });
}
/**
 * workspace guide 更新当前用户已完成的步骤
 * @param {Array} data {key: '', value: any}
 */
export function updateGuideOnceLogApi(data) {
    return psHttp({
        cache: false,
        url: `${coreBasicApiUrlPrefix}/analytics/guide`,
        headers: { 'X-API-Version': '2.0' },
        method: 'POST',
        data: data,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
* 获取workspace已经记录过的guide步骤
*/
export function getGuideOnceLogApi(type) {
    return psHttp({
        cache: false,
        url: `${coreBasicApiUrlPrefix}/analytics/guide`,
        headers: { 'X-API-Version': '2.0' },
        params: {
            module_type: type,
        },
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getKeyWordsApi(query = '', params = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/helper/keyword`,
        method: 'POST',
        data: {
            query,
            ...params,
        },
        transformCode: true,
    });
}
// corporateTree
export function getCorporateTreeApi(params = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/helper/corporate-tree`,
        method: 'GET',
        params,
        transformCode: true,
    }).then(({ data }) => {
        return data || {};
    });
}
// corporateTree
export function getPatsnapTreeApi(params = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/helper/patsnap-tree`,
        method: 'GET',
        params,
        transformCode: true,
    }).then(({ data }) => {
        return data || {};
    });
}
export function searchAssignApi(keyword) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/assignee`,
        method: 'GET',
        params: {
            keyword,
        },
        transformCode: true,
    });
}
export function searchGnameApi(keyword) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/gname`,
        method: 'GET',
        params: {
            keyword,
        },
        transformCode: true,
    });
}
// 添加历史记录
export function addImageHistoryApi(params) {
    return psHttp({
        // ...baseHttpConfig,
        url: `${coreSearchApiUrlPrefix}/image/history`,
        method: 'POST',
        data: {
            patent_id: params.patentId,
            img_id: params.imgId,
            patent_type: params.patent_type,
        },
    });
}
export function transferChemicalApi(data) {
    return psHttp({
        url: `${chemicalAipUrlPrefix}/chemical-external/analytics/query/chemical-structure`,
        method: 'POST',
        headers: {
            'X-API-Version': '1.0',
        },
        data,
    }).then((data) => {
        return _.get(data, 'data', {});
    });
}
// 导出project
export function exportProjectSubmit(data) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/command-search/submit`,
        method: 'POST',
        data,
        transformCode: true,
    });
}
export function exportProjectPreviewViewInit({ project_id, space_id, folder_id, }) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/command-search/project-view/init`,
        method: 'POST',
        data: {
            project_id: _.isArray(project_id) ? project_id.join(',') : project_id,
            space_id,
            folder_id,
        },
        transformCode: true,
    }).then((data) => {
        return data.data || {};
    });
}
export function getSearchSuggestApi({ fields, keyword }) {
    const lang = getCurrentLanguage();
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/smart/suggest`,
        method: 'POST',
        transformCode: true,
        headers: {
            'X-Site-Lang': lang.toUpperCase(),
        },
        data: {
            fields: fields.join(','),
            keyword,
        },
    });
}
export function compareInitApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/compare/v2/compare-init`,
        method: 'POST',
        data,
        cache: true,
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
export function getDatabaseConfig() {
    return new Promise((resolve) => {
        const time = new Date().getTime();
        const dataBaseConfigStr = sessionStorage.getItem('dataBaseConfig');
        let dataBaseConfig = null;
        // 添加缓存时效
        const dataBaseConfigTime = _.toNumber(sessionStorage.getItem('dataBaseConfigTime')) || 0;
        const overTime = time - dataBaseConfigTime > 1 * 60 * 60 * 1000;
        if (dataBaseConfigStr) {
            dataBaseConfig = JSON.parse(dataBaseConfigStr);
        }
        if (!overTime && dataBaseConfig && dataBaseConfig.patentTypes && dataBaseConfig.patentCountries) {
            resolve(dataBaseConfig);
        }
        else {
            psHttp({
                method: 'GET',
                url: `${coreBasicApiUrlPrefix}/analytics/db-select/config`,
                headers: {
                    'X-API-Version': '1.0',
                    'X-Device-ID': currentClientUUID(),
                },
            }).then(res => {
                const data = _.get(res, 'data.data');
                if (data) {
                    dataBaseConfig = data;
                    sessionStorage.setItem('dataBaseConfig', JSON.stringify(dataBaseConfig));
                    sessionStorage.setItem('dataBaseConfigTime', time.toString());
                    resolve(dataBaseConfig);
                }
            });
        }
    });
}
